import React from 'react';
import styles from './cropping-preset-item.module.scss';
import {IconBox} from '../../../../icon-box';

interface CroppingPresetItemProps {
  val: number;
  isActive: boolean;
  icon: string;
  onSelected: Function;
  label: string;
  className?: string;
}

export function CroppingPresetItem({className = '', ...props}: CroppingPresetItemProps) {
  return (
    <li className={className} onClick={props.onSelected.bind(null, props.val)} key={props.val}>
      <IconBox className={styles.iconBox} icon={props.icon} isSelected={props.isActive} text={props.label} />
    </li>
  );
}
